import React, { useEffect, useState } from "react";
import { useField, useValidation } from "usetheform";
import { DropzoneArea } from "material-ui-dropzone";
import { Button } from "@mui/material";
import axios from "../../../../utils/apidsf";
import swal from "sweetalert";
import useUpload from "../../../../hooks/UseUpload";
const required = (value) => (value ? undefined : "Attachments Required");
export const MaterialuiDropzone = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { upload: tryFiles } = useUpload();
  const [status, validation] = useValidation([required]);
  const { value, setValue } = useField({
    type: "custom",
    touched: true,
    name: "materialuiDropzone",
    ...validation,
  });
  const [image, setimage] = useState([]);
  const [itration, setitration] = useState(0);
  const handleChange = (files) => {
    setSelectedFiles(files);
  };

  const imagedetails = async () => {
    for (let i = 0; i < selectedFiles.length; i++) {
      const pics = selectedFiles[i];
      setitration(i);
      if (pics === undefined) {
        alert("findshed");
        return;
      }
      if (pics.type === "image/jpeg" || pics.type === "image/png") {
        try {
          const response = await tryFiles(pics);
          setimage((datas) => [...datas, response.data.source_url]);
        } catch (err) {
          console.log(err);
          swal({ title: "Error", text: "Unable to upload", icon: "Error" });
        }
      }
    }
  };

  const upload = () => {
    let token = JSON.parse(localStorage.getItem("token"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    };
    const imageurl = image;
    axios
      .post("/admin/createcarousel", { imageurl }, config)
      .then((e) => {
        setimage([]);
      })
      .catch((err) => {
        swal("Failed!", "Failed to upload images", "Error");
      });
  };

  useEffect(() => {
    if (itration + 1 == selectedFiles.length) {
      // alert("finidhed");
      upload();
      setitration(0);
      swal("Uploaded!", "Carousel image Uploaded Sucessfully!", "success");
      return;
    }
    return () => {};
  }, [image]);

  // console.log(image);
  return (
    <div>
      <DropzoneArea
        maxFileSize={10000000}
        filesLimit={100}
        onChange={handleChange}
      />
      {status.error && <span className="Error">{status.error}</span>}
      <Button
        className="create_user_btn"
        variant="contained"
        style={{ margin: "20px" }}
        onClick={imagedetails}
      >
        Upload image
      </Button>
    </div>
  );
};
